import { PopoverContent } from './CommercialProductContent.js';
import { t } from '../../../common/i18n/index.js';

export const LiikkuvaWifiPopOverContent = () => (
  <PopoverContent>
    <div>{t.Q8ZW('Includes a battery-powered portable mobile router with the best battery life on the market.')}</div>
  </PopoverContent>
);
